import { coberturasPorNombre } from 'constantes/globalsStates'
import {
  START_YEAR,
  NUM_OF_YEARS,
  MONTH_NAMES,
  MONTHS_PER_YEAR,
  QUARTERS_PER_YEAR,
  MONTHS_PER_QUARTER,
  NUM_OF_MONTHS,
  MAX_TRACK_START_GAP,
  MAX_ELEMENT_GAP,
  MAX_MONTH_SPAN,
  MIN_MONTH_SPAN,
  MAX_NUM_OF_SUBTRACKS,
} from './constants'

import { fill, hexToRgb, colourIsLight, addMonthsToYear, addMonthsToYearAsDate, nextColor, randomTitle } from './utils'
import { functions } from 'constantes/functions'

export const buildQuarterCells = () => {
  const v = []
  for (let i = 0; i < QUARTERS_PER_YEAR * NUM_OF_YEARS; i += 1) {
    const quarter = (i % 4) + 1
    const startMonth = i * MONTHS_PER_QUARTER
    const s = addMonthsToYear(START_YEAR, startMonth)
    const e = addMonthsToYear(START_YEAR, startMonth + MONTHS_PER_QUARTER)
    v.push({
      id: `${s.year}-q${quarter}`,
      title: `${s.year}`,
      start: new Date(`${s.year}-${s.month}-01`),
      end: new Date(`${e.year}-${e.month}-01`),
    })
  }
  return v
}

const styleGeneral = {
  backgroundColor: "rgb(0, 133, 182)",
  color: "#ffffff",
  borderRadius: "4px",
  boxShadow: "1px 1px 0px rgba(0, 0, 0, 0.25)",
  textTransform: "capitalize",
};


export const buildMonthCells = () => {

  const v = [];
  for (let i = 0; i < MONTHS_PER_YEAR * NUM_OF_YEARS ; i += 1) {
    const startMonth = i;
    const start = addMonthsToYearAsDate(2023, startMonth);
    const end = addMonthsToYearAsDate(2023, startMonth + 1);

    // Calcula todos los días desde el día inicial hasta el día final del mes
    const days = [];
    for (let d = start; d < end; d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)) {
      days.push(new Date(d));
    }

    v.push({
      id: `m${i}`,
      title: MONTH_NAMES[i % 12],
      days, // Agrega un arreglo con todos los días en el mes,
      start,
      end,
    });
  }
  return v;
}

export const buildTimebar = () => [
  {
    id: 'quarters',
    title: 'Año',
    cells: buildQuarterCells(),
    style: {},
  },
  {
    id: 'months',
    title: 'Meses',
    cells: buildMonthCells(),
    useAsGrid: true,
    style: {},
  },
  // {
  //   id: 'days',
  //   title: 'Días',
  //   cells: [],
  //   useAsGrid: true,
  //   style: {},
  // },
]

export const buildElement = ({ trackId, start, end, i }) => {
  const bgColor = nextColor()
  const color = colourIsLight(...hexToRgb(bgColor)) ? '#000000' : '#ffffff'
  return {
    id: `t-${trackId}-el-${i}`,
    title: randomTitle(),
    start,
    end,
    style: {
      backgroundColor: `#${bgColor}`,
      color,
      borderRadius: '4px',
      boxShadow: '1px 1px 0px rgba(0, 0, 0, 0.25)',
      textTransform: 'capitalize',
    },
  }
}

export const buildTrackStartGap = () => Math.floor(Math.random() * MAX_TRACK_START_GAP)
export const buildElementGap = () => Math.floor(Math.random() * MAX_ELEMENT_GAP)

export const buildElements = trackId => {
  const v = []
  let i = 1
  let month = buildTrackStartGap()

  while (month < NUM_OF_MONTHS) {
    let monthSpan = Math.floor(Math.random() * (MAX_MONTH_SPAN - (MIN_MONTH_SPAN - 1))) + MIN_MONTH_SPAN

    if (month + monthSpan > NUM_OF_MONTHS) {
      monthSpan = NUM_OF_MONTHS - month
    }

    const start = addMonthsToYearAsDate(START_YEAR, month)
    const end = addMonthsToYearAsDate(START_YEAR, month + monthSpan)
    v.push(
      buildElement({
        trackId,
        start,
        end,
        i,
      })
    )
    const gap = buildElementGap()
    month += monthSpan + gap
    i += 1
  }

  return v
}

export const buildSubtrack = (trackId, subtrackId) => ({
  id: `track-${trackId}-${subtrackId}`,
  title: `Subtrack ${subtrackId}`,
  elements: buildElements(subtrackId),
})

export const buildTrack = trackId => {
  const tracks = fill(Math.floor(Math.random() * MAX_NUM_OF_SUBTRACKS) + 1).map(i => buildSubtrack(trackId, i + 1))
  return {
    id: `track-${trackId}`,
    title: `Track ${trackId}`,
    elements: buildElements(trackId),
    tracks,
    // hasButton: true,
    // link: 'www.google.com',
    isOpen: false,
  }
}


const generarNumeroAleatorio = (max = 50000, min = 1) => {
  return Math.floor((Math.random() * (max - min + 1)) + min);
}

export const generarDatosJson = (datos) => {
  const datosGenerados = [];

  // Crear una función para encontrar una cobertura existente por su idComparar
  function findCoberturaByIdComparar(idComparar) {
    return datosGenerados.find((item) => item.idComparar === idComparar);
  }

  // Crear una función para encontrar una empresa existente en una cobertura
  function findEmpresaInCobertura(cobertura, nombreEmpresa) {
    return cobertura.tracks.find((empresa) => empresa.idComparar === nombreEmpresa.trim());
  }

  // Crear una función para encontrar un medio existente en una empresa
  function findMedioInEmpresa(empresa, nombreMedio) {
    return empresa.tracks.find((medio) => medio.idComparar === nombreMedio.trim());
  }

  // Crear una función para encontrar una eleccion en un medio
  function findEleccionInMedio(medio, eleccion) {
    return medio.tracks.find((itemEleccion) => itemEleccion.idComparar === eleccion.trim());
  }

  // Crear una función para encontrar una organizacion politica en una eleccion
  function findPartidoInOrganizacionPolitica(eleccion, orgPolitica) {
    return eleccion.tracks.find((itemOrgPolitica) => itemOrgPolitica.idComparar === orgPolitica.trim());
  }

  datos.forEach(
    ({ tarifaElectoral, nivelCobertura, nombreMedio, nombreEmpresa, fechaAsignacion, eleccion, cantidadAsignadaTotal, nit, orgPolitica }) => {
      // Buscar si la cobertura ya existe
      let cobertura = findCoberturaByIdComparar(nivelCobertura);

      if (!cobertura) {
        // Si no existe, crea una nueva cobertura
        cobertura = {
          id: `${nivelCobertura}_${datosGenerados.length + generarNumeroAleatorio()}_${new Date().getTime()}`,
          title: `COBERTURA ${nivelCobertura} - VALOR Q. ${Number(tarifaElectoral).toFixed(2)}`,
          idComparar: nivelCobertura.trim(),
          isOpen: true,
          idCobertura: coberturasPorNombre[nivelCobertura]?.id || 0,
          cobertura: coberturasPorNombre[nivelCobertura],
          nit,
          subListItem: "cobertura",
          elements: [],
          tracks: [],
        };
        datosGenerados.push(cobertura);
      }

      // Buscar si la empresa ya existe en la cobertura
      let empresa = findEmpresaInCobertura(cobertura, nombreEmpresa);

      if (!empresa) {
        // Si no existe, crea una nueva empresa
        empresa = {
          id: `${nombreEmpresa.trim()}_${datosGenerados.length + generarNumeroAleatorio()}_${new Date().getTime()}`,
          idComparar: nombreEmpresa.trim(),
          title: nombreEmpresa.trim(),
          subListItem: "empresa",
          idCobertura: coberturasPorNombre[nivelCobertura]?.id || 0,
          isOpen: true,
          elements: [],
          tracks: [],
        };
        cobertura.tracks.push(empresa);
      }

      // Buscar si el medio ya existe en la empresa
      let medio = findMedioInEmpresa(empresa, nombreMedio);

      if (!medio) {
        // Si no existe, crea un nuevo medio
        medio = {
          id: `${nombreMedio.trim()}_${datosGenerados.length + generarNumeroAleatorio()}_${new Date().getTime()}`,
          idComparar: nombreMedio.trim(),
          title: nombreMedio.trim(),
          subListItem: "medio",
          idCobertura: coberturasPorNombre[nivelCobertura]?.id || 0,
          idEmpresa: nombreEmpresa.trim(),
          isOpen: true,
          elements: [],
          tracks: [],
        };
        empresa.tracks.push(medio);
      }

      // Buscar si la eleccion ya existe en el medio
      let eleccionEncontrada = findEleccionInMedio(medio, eleccion);

      if (!eleccionEncontrada) {
        // Si no existe, crea una nueva eleccion
        eleccionEncontrada = {
          id: `${eleccion.trim()}_${datosGenerados.length + generarNumeroAleatorio()}_${new Date().getTime()}`,
          idComparar: eleccion.trim(),
          title: eleccion.trim(),
          subListItem: "eleccion",
          idCobertura: coberturasPorNombre[nivelCobertura]?.id || 0,
          idEmpresa: nombreEmpresa.trim(),
          idMedio: nombreMedio.trim(),
          isOpen: true,
          elements: [],
          tracks: [],
        };
        medio.tracks.push(eleccionEncontrada);
      }

      // Buscar si el partido ya existe en la eleccion
      let organizacionPolitica = findPartidoInOrganizacionPolitica(eleccionEncontrada, orgPolitica);

      if (!organizacionPolitica) {
        // Si no existe, crea una nueva organizacionPolitica
        organizacionPolitica = {
          id: `${orgPolitica.trim()}_${datosGenerados.length + generarNumeroAleatorio()}_${new Date().getTime()}`,
          idComparar: orgPolitica.trim(),
          title: orgPolitica.trim(),
          elements: [],
        };
        eleccionEncontrada.tracks.push(organizacionPolitica);
      }

      const elemento = {
        id: `${orgPolitica.trim()}_${generarNumeroAleatorio()}_${new Date().getTime()}`,
        idComparar: orgPolitica.trim(),
        title: cantidadAsignadaTotal?.toString(),
        start: new Date(functions.formatearFecha_MM_DD_YYYY(fechaAsignacion || "")),
        end: new Date(functions.formatearFecha_FINAL_MM_DD_YYYY(fechaAsignacion || "")),
        style: styleGeneral,
      };

      organizacionPolitica.elements.push(elemento);

    }
  );

  return datosGenerados;
};